import style from './SubBlockList.module.scss';

import { SubBlockItem } from './SubBlockItem';

export interface SubBlockListProps {}

interface Props extends SubBlockListProps {
    blockIndexes: number[];
}

export function SubBlockList({ blockIndexes }: Props) {
    // @ts-ignore
    return (
        blockIndexes.length > 0 && (
            <div className={style.root}>
                {blockIndexes.map(index => (
                    <div
                        key={index}
                        className={style.subBlockItem}
                    >
                        <SubBlockItem subBlockIndex={index} />
                    </div>
                ))}
            </div>
        )
    );
}
